import { AppState } from '../../../../redux/reducers';

// stores
import * as ProtocolPractitionersStore from '../../../../redux/middleware/ProtocolPractitionersMiddleware';

interface IProps {
  isOpen: boolean;
  onClose: () => void;
}

interface ConnectedProps {
  isExportingExcel: boolean;
  successExportingExcel: boolean | undefined;
  failOnExportingExcel: boolean;
}

interface DispatchProps {
  ExportPractitionerAssociationsToExcel: typeof ProtocolPractitionersStore.actionCreators.ExportPractitionerAssociationsToExcel;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => ({
  isExportingExcel: state.ProtocolPractitioners?.isExportingExcel,
  successExportingExcel: state.ProtocolPractitioners?.successExportingExcel,
  failOnExportingExcel: state.ProtocolPractitioners?.failOnExportingExcel
});

export const mapDispatchToProps = {
  ...ProtocolPractitionersStore.actionCreators
};
